import { createApi } from '@reduxjs/toolkit/query/react';

import {
  PassportRequestFormPostRequest,
  HrmRequestFormResponse,
} from '@Types/api/form';
import { ApiBaseName, ApiReducerPath, RequestTypeCodes } from '@Enum/index';
import {
  RequestListSearchRequest,
  RequestListSearchResponse,
} from '@Types/api/requestList';
import { PAGE_SIZE, TABLE_PAGE_DEFAULT } from '@Features/constants';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

const REQ_TYPE_FILTER = {
  name: 'requestTypeID',
  value: RequestTypeCodes.PASSPORT_REQUEST,
  operator: 'eq',
};

export const passportRequestApi = createApi({
  tagTypes: ['passportRequest'],
  reducerPath: ApiReducerPath.API_PASSPORT_REQUEST,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getPassportRequests: builder.mutation<
      RequestListSearchResponse<HrmRequestFormResponse>,
      RequestListSearchRequest
    >({
      query: ({
        searchValue,
        filters = [],
        page = TABLE_PAGE_DEFAULT,
        size = PAGE_SIZE,
        sortBy = 'requestId',
        sortOrder = 'desc',
      }) => ({
        url: `${ApiBaseName.ESS}/hrm-request/search`,
        method: 'post',
        body: {
          searchValue,
          searchCriteriaList: [
            {
              searchCriterias: [...filters, REQ_TYPE_FILTER],
              dataOperator: 'and',
            },
          ],
          dataOperator: 'and',
        },
        params: { page, size, 'sort-by': sortBy, 'sort-order': sortOrder },
      }),
    }),
    postPassportForm: builder.mutation<
      HrmRequestFormResponse,
      PassportRequestFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request`,
        method: 'post',
        body: {
          ...body,
          requestTypeID: RequestTypeCodes.PASSPORT_REQUEST,
        },
      }),
    }),
    formValidation: builder.mutation<
      HrmRequestFormResponse,
      PassportRequestFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request/validate`,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const {
  usePostPassportFormMutation,
  useFormValidationMutation,
  useGetPassportRequestsMutation,
} = passportRequestApi;
